import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { Button, Dialog, Grid, TextField } from '@mui/material';
import PopupTitle from '../common/popup_title';
import { boardWithMenuAdded } from '../../services/smorg_board';
import {
  useGetSmorgBoardQuery,
  useUpdateSmorgBoardMutation,
} from '../../app/smorgAppSyncGraphQLApi';

const RecipeCollectionsNewMenuModal = ({ boardID, onDismiss }) => {
  const [menuTitle, setMenuTitle] = useState('');

  const isValid = !!menuTitle;

  const [updateSmorgBoard] = useUpdateSmorgBoardMutation();

  const { data: ownRecipesBoard } = useGetSmorgBoardQuery(boardID, {
    skip: !boardID,
  });

  const onCreate = async () => {
    const newBoard = boardWithMenuAdded(ownRecipesBoard, uuid(), menuTitle);
    await updateSmorgBoard(newBoard);
    onDismiss();
  };

  return (
    <Dialog
      open
      // size="md"
      PaperProps={{
        style: {
          width: '420px',
          height: '160px',
          padding: '10px',
        },
      }}
      onClose={onDismiss}>
      <Grid container>
        <Grid item xs={12}>
          <PopupTitle
            closeButtonEnabled
            onClickClose={onDismiss}
            titleText="Add new menu"
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          <TextField
            value={menuTitle}
            onChange={(ev) => {
              setMenuTitle(ev.target.value);
            }}
            autoFocus
            margin="dense"
            label=""
            type="text"
            fullWidth
            size="small"
            variant="standard"
            placeholder="e.g. Healthy Lunches"
          />
        </Grid>
        <Grid item xs={12} style={{ padding: '5px' }}>
          <Button
            onClick={(ev) => {
              onCreate();
              ev.stopPropagation();
            }}
            variant="contained"
            size="medium"
            disabled={!isValid}
            disableElevation>
            Add
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
};

RecipeCollectionsNewMenuModal.propTypes = {
  boardID: PropTypes.string.isRequired,
  onDismiss: PropTypes.func.isRequired,
};

export default RecipeCollectionsNewMenuModal;
